import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { getSignedInUserName, signOut } from "services/auth";
import { Button } from "ui/components/Button/Button";

import { Routes } from "../../navigation";
import { UnauthorizedPageCmp } from "./types";

/**
 * Prijavljen je netko tko nije naše osoblje.
 *
 * Jedini izlaz je odjava. Prijelaz na drugu rutu ne pomaže: `AuthWrapper` na svakoj provjeri
 * ponovno zatekne isti token bez `is_superuser` i vrati ovamo. Zato ovdje nema ni „Početna" ni
 * „Natrag" — prva je vrtjela u krug, a druga je bila `navigate(-1)`, obična povijest
 * preglednika, koja je nakon `replace` preusmjeravanja vodila van aplikacije.
 */
const UnauthorizedPage: UnauthorizedPageCmp = () => {
  const dispatch = useDispatch();

  const userName = getSignedInUserName();

  const handleSignOut = useCallback(() => {
    dispatch(signOut() as any);
  }, [dispatch]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-md w-full bg-white shadow-xl rounded-lg p-8">
        <div className="flex flex-col items-center text-center">
          <div className="mb-6">
            <svg
              className="w-20 h-20 text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v.01M12 9v3m0-9a9 9 0 100 18 9 9 0 000-18z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-3">Nemate pristup</h1>

          <p className="text-gray-600 mb-2">
            Administracija je namijenjena isključivo osoblju AutoBiza.
          </p>

          {userName && (
            <p className="text-gray-500 text-sm mb-6">
              Prijavljeni ste kao <span className="font-medium">{userName}</span>. Taj račun
              nema pravo pristupa administraciji.
            </p>
          )}

          {!userName && <div className="mb-6" />}

          <Button onClick={handleSignOut} variant="primary" size="full">
            Odjava i prijava drugim računom
          </Button>
        </div>
      </div>
    </div>
  );
};

UnauthorizedPage.route = Routes.UnauthorizedPage;

export default UnauthorizedPage;
